import CtaModal from './CtaModal';

export default CtaModal;
